// $(function() {
// 	$('div.spoiler-title').click(function() {
// 		$(this)
// 			.children()
// 			.first()
// 			.toggleClass('show-icon')
// 			.toggleClass('hide-icon');
// 		$(this)
// 			.parent().children().last().toggle();
// 	});
// });